import { HTTP } from "@/common/http-common";

const RESOURCE_NAME = "entities/teacherAvailabilitys";

export default {
  async saveConfiguration(availabilities, teacherId, init, end) {
    return (
      await HTTP.post(
        `${RESOURCE_NAME}/configuration/${teacherId}`,
        availabilities,
        {
          params: {
            init: init,
            end: end,
          },
        }
      )
    ).data;
  },
};
